import AboutBg from '../assets/images/about-hero-ai-office.jpg'
import AboutImg from "../assets/images/about-who-we-are-keyboard.jpg";
import { TbTargetArrow } from "react-icons/tb";
import { MdOutlineVisibility } from "react-icons/md";
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import ToTop from '../components/ToTop';

const WHAT_WE_DO = [
  {
    title: 'AI Solutions',
    body: "We build AI voice bots, chatbots, and business process automations that plug into how your team already works, cutting manual handling time on support, onboarding, and repetitive workflows without adding new systems to learn.",
    to: '/Services#ai-agents',
    label: 'Explore AI Solutions',
  },
  {
    title: 'AWS & Cloud Services',
    body: "We run the full AWS lifecycle: 24/7 managed services with monitoring and governance, migration and modernization for legacy systems, infrastructure assessments, cost optimization through right-sizing, and architecture consulting for security and scale.",
    to: '/Services#cloud-migration-modernization',
    label: 'Explore Cloud Services',
  },
  {
    title: 'Software Development',
    body: "We build custom web applications, backend systems, and API gateways with centralized traffic management, cloud-native from the start, so what we ship on AWS today doesn't need re-architecting as you grow.",
    to: '/Services#custom-software-web-applications',
    label: 'Explore Software Development',
  },
  {
    title: 'Digital Transformation',
    body: "We pair hands-on AWS and AI delivery with the strategy work most technical vendors skip: assessing where you are, building a roadmap, and transferring the knowledge to your team so you're not left dependent on us to run it.",
    to: '/Services#cloud-digital-transformation-strategy',
    label: 'Explore Digital Transformation',
  },
];

const WHO_WE_HELP = [
  { title: 'Sports & Entertainment', body: 'We help sports and entertainment organizations use cloud and digital technologies to improve fan and customer engagement and scale operations.' },
  { title: 'Financial Services', body: 'We support financial services businesses with secure, scalable cloud infrastructure and technology solutions built for regulated environments.' },
  { title: 'Education', body: 'We support educational organizations with scalable cloud infrastructure, digital platforms and technology solutions that improve efficiency and accessibility.' },
  { title: 'Healthcare', body: 'We help healthcare organizations adopt AI readiness and cloud managed services that improve operational efficiency and patient and staff experience.' },
  { title: 'Retail', body: 'We help retail businesses modernize commerce platforms, integrate cloud infrastructure and apply automation to customer engagement and operations.' },
];

const WHY_CHOOSE = [
  { title: 'AI + Cloud Expertise', body: 'We combine AI capabilities with cloud and software engineering expertise to create practical solutions for real business challenges.' },
  { title: 'Business-First Approach', body: 'We start by understanding your business objectives and challenges before recommending technology or designing a solution.' },
  { title: 'Scalable Solutions', body: 'We design solutions that can evolve with your business, helping you scale without creating unnecessary technology complexity.' },
  { title: 'Cost-Conscious Technology', body: 'We help businesses make better use of their technology investments through cloud optimization, automation and efficient solution design.' },
  { title: 'End-to-End Support', body: 'From assessment and strategy to implementation, management and optimization, we can support your technology journey from start to finish.' },
];

const HOW_WE_WORK = [
  { num: '01', title: 'Understand', body: 'We begin by understanding your business objectives, current technology environment and key challenges.' },
  { num: '02', title: 'Assess', body: 'We identify opportunities for AI adoption, cloud optimization, automation, modernization and digital improvement.' },
  { num: '03', title: 'Design', body: 'We develop a practical solution and technology roadmap aligned with your business priorities, requirements and budget.' },
  { num: '04', title: 'Implement', body: 'Our team implements the solution using appropriate AI, cloud and software technologies with a focus on security, scalability and reliability.' },
  { num: '05', title: 'Optimize', body: 'We continuously look for opportunities to improve performance, efficiency, security and cost as your business evolves.' },
];

const FAQS = [
  { q: 'What does Jaggulas Consulting do?', a: 'Jaggulas Consulting is a technology consulting company specializing in AI solutions, AWS cloud services, software development and digital transformation. We help businesses improve efficiency, modernize technology and build scalable digital solutions.' },
  { q: 'What AI services does Jaggulas Consulting provide?', a: 'Jaggulas Consulting provides AI voice agents, AI automation, generative AI solutions and AI-powered business workflows designed to improve efficiency and customer experiences.' },
  { q: 'Does Jaggulas Consulting provide AWS services?', a: 'Yes. Jaggulas Consulting provides AWS and cloud services including cloud consulting, managed services, cloud assessments, migration, modernization and cloud cost optimization.' },
  { q: 'Does Jaggulas Consulting provide software development?', a: 'Yes. We develop web applications, backend systems, APIs, integrations and custom software solutions designed around specific business requirements.' },
  { q: 'Where does Jaggulas Consulting operate?', a: 'Jaggulas Consulting operates across South Africa and India, supporting businesses with AI, AWS cloud, software development and digital transformation solutions.' },
  { q: 'Which industries does Jaggulas Consulting serve?', a: 'Jaggulas Consulting supports organizations across industries including sports and entertainment, financial services, education, healthcare and retail.' },
  { q: 'How can I work with Jaggulas Consulting?', a: 'You can contact Jaggulas Consulting to discuss your AI, cloud, software development or digital transformation requirements. Our team can help you understand the right technology approach for your business.' },
];

export default function About() {
  return (
    <div>
      {/* Hero section */}
      <div className="row">
        <div className="col banner-bg">
          <img src={AboutBg} alt="AI and cloud technology at Jaggulas Consulting" className="about-hero-img" />
          <div className="container bg-content">
            <div className="banner-bg-content p-5">
              <span className="about-eyebrow">AI, AWS Cloud &amp; Digital Transformation Partner</span>
              <h1>About Jaggulas Consulting</h1>
              <p className="about-hero-lede">
                Jaggulas Consulting is a technology consulting company helping businesses harness AI, AWS cloud
                and modern digital technologies to solve real-world business challenges. We combine AI solutions,
                cloud expertise and software development to help organizations improve operational efficiency,
                modernize their technology and build scalable digital solutions.
              </p>
              <div className="services-hero-cta">
                <Link to="/Services" className="services-hero-btn services-hero-btn-primary">Explore Our Services</Link>
                <Link to="/Contact" className="services-hero-btn services-hero-btn-ghost">Talk to Our Team</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Hero section ends*/}

      {/* Who We Are */}
      <div className="section-bg1 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <div className="row py-5 g-4 d-flex justify-content-center">
            <div className="col-md-6">
              <div className="about-img-wrap">
                <img src={AboutImg} alt="About Jaggulas Consulting" className="about-img" />
              </div>
            </div>
            <div className="col-md-6 text">
              <h2 className="fw-bold mb-3 about-heading">Who We Are</h2>
              <p><strong>Technology should solve business problems, not create more of them.</strong></p>
              <p>
                At Jaggulas Consulting, we work closely with businesses to understand their challenges, identify
                opportunities and implement practical technology solutions that deliver measurable value.
              </p>
              <p>
                Our expertise spans artificial intelligence, AWS cloud services, software development, cloud
                migration, modernization and digital transformation. From helping businesses adopt AI to managing
                and optimizing cloud environments, we support organizations throughout their technology journey.
              </p>
              <p>
                Our approach is simple: understand the business first, choose the right technology, and build
                solutions that are secure, scalable and designed for long-term growth.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Who We Are ends */}

      {/* What We Do */}
      <div className="section-bg2 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <h2 className="fw-bold about-heading">What We Do</h2>
          <p className="about-section-intro">We bring together AI, cloud and software engineering capabilities to help businesses modernize, automate and grow.</p>
          <div className="about-card-grid">
            {WHAT_WE_DO.map((item) => (
              <div className="about-card" key={item.title}>
                <h3 className="card-heading">{item.title}</h3>
                <p>{item.body}</p>
                <HashLink to={item.to} className="about-card-link">{item.label} &rarr;</HashLink>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* What We Do ends */}

      {/* Who We Help */}
      <div className="section-bg1 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <h2 className="fw-bold about-heading">Who We Help</h2>
          <p className="about-section-intro">We work with organizations that want to modernize their technology, adopt AI and build more efficient digital operations.</p>
          <div className="about-card-grid">
            {WHO_WE_HELP.map((item) => (
              <div className="about-card" key={item.title}>
                <h3 className="card-heading">{item.title}</h3>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Who We Help ends */}

      {/* Why Choose Jaggulas Consulting */}
      <div className="section-bg2 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <h2 className="fw-bold about-heading">Why Choose Jaggulas Consulting?</h2>
          <div className="about-card-grid">
            {WHY_CHOOSE.map((item) => (
              <div className="about-card" key={item.title}>
                <h3 className="card-heading">{item.title}</h3>
                <p>{item.body}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Why Choose Jaggulas Consulting ends */}

      {/* How We Work */}
      <div className="section-bg1 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <h2 className="fw-bold about-heading">How We Work</h2>
          <ul className="about-steps">
            {HOW_WE_WORK.map((step) => (
              <li className="about-step" key={step.num}>
                <span className="about-step-num" aria-hidden="true">{step.num}</span>
                <div>
                  <h3 className="card-heading">{step.title}</h3>
                  <p>{step.body}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {/* How We Work ends */}

      {/* Vision & Mission */}
      <div className="location-section">
        <div className="about-wrap py-5">
          <div className="about-vm-grid">
            <div className="vision-cont about-vm-card">
              <div className="vision-icon"><MdOutlineVisibility /></div>
              <h3 className="card-heading">Our Vision</h3>
              <p>
                To shape the future of technology by providing cutting-edge cloud solutions and Advanced Technology Architecture, empowering organizations to innovate and thrive. We aim to be a catalyst for digital transformation, fostering a resilient and interconnected digital landscape that benefits businesses and communities alike.
              </p>
            </div>

            <div className="vision-cont about-vm-card">
              <div className="vision-icon"><TbTargetArrow /></div>
              <h3 className="card-heading">Our Mission</h3>
              <p>
                To empower businesses through innovative cloud-based solutions and exceptional software development, enhancing collaboration, scalability, and operational efficiency, and driving seamless digital transformation.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Vision & Mission ends */}

      {/* Built to Solve Real Business Challenges */}
      <div className="section-bg2 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <h2 className="fw-bold about-heading">Built to Solve Real Business Challenges</h2>
          <p className="about-section-intro">
            We believe technology consulting should be measured by business outcomes, not simply by the
            technologies used. Our team works closely with organizations to turn technology challenges into
            practical solutions, from modernizing infrastructure and optimizing cloud environments to
            implementing AI-powered business processes.
          </p>
        </div>
      </div>
      {/* Built to Solve Real Business Challenges ends */}

      {/* FAQ */}
      <div className="section-bg1 border-bottom border-secondary">
        <div className="about-wrap py-5">
          <h2 className="fw-bold about-heading">Frequently Asked Questions</h2>
          <div>
            {FAQS.map((item) => (
              <details className="about-faq-item" key={item.q}>
                <summary>{item.q}</summary>
                <p>{item.a}</p>
              </details>
            ))}
          </div>
        </div>
      </div>
      {/* FAQ ends */}

      {/* Final CTA */}
      <div className="about-cta-band text-center py-5">
        <div className="about-wrap">
          <h2 className="fw-bold">Ready to Transform Your Business?</h2>
          <p>Whether you are looking to adopt AI, modernize your cloud environment, develop a digital solution or optimize your existing technology, we can help you take the next step.</p>
          <div className="services-hero-cta justify-content-center">
            <Link to="/Contact" className="services-hero-btn services-hero-btn-primary">Talk to Our Team</Link>
            <Link to="/Services" className="services-hero-btn services-hero-btn-ghost">Explore Our Services</Link>
          </div>
        </div>
      </div>
      {/* Final CTA ends */}

      {/* To top icon */}
      <ToTop />
      {/* To top icon */}
    </div>
  )
}
